import { account } from "./appwrite.js";
import { clearGatewayJwtCache } from "./stripe.js";

const FROM_PASSWORD_RESET_FLAG = "heycoach:fromPasswordReset";

export function stashFromPasswordReset() {
  try {
    sessionStorage.setItem(FROM_PASSWORD_RESET_FLAG, "1");
  } catch {
    // sessionStorage unavailable
  }
}

/** One-shot flag so login does not auto-redirect after a password reset. */
export function consumeFromPasswordReset() {
  try {
    const value = sessionStorage.getItem(FROM_PASSWORD_RESET_FLAG);
    if (!value) return false;
    sessionStorage.removeItem(FROM_PASSWORD_RESET_FLAG);
    return true;
  } catch {
    return false;
  }
}

/** Drop any Appwrite session cookie before sign-in or after sign-out. */
export async function clearAppwriteSession() {
  clearGatewayJwtCache();
  try {
    await account.deleteSession("current");
    return;
  } catch {
    // fall through to delete all sessions
  }

  try {
    await account.deleteSessions();
  } catch {
    // session already cleared or unavailable
  }
}

export async function signInWithEmailPassword(email, password) {
  await clearAppwriteSession();
  await account.createEmailPasswordSession(email, password);
}

/**
 * Navigate away first so RoleRoute cannot attach a stale `from` path, then
 * revoke the Appwrite session and clear client auth state.
 */
export async function performSignOut({ clearSession, navigate }) {
  await clearAppwriteSession();
  clearSession();
  navigate("/login", { replace: true, state: null });
}
